import { useEffect, useCallback, useRef } from "react";
import { useSocket } from "../redux/socket/useSocket.js";

export const useGroupMemberUpdates = (channelId, onMembersUpdated) => {
  const { sendCommand, subscribeToSocketMessages } = useSocket();
  const subscriptionHandlerRef = useRef(null);

  const handleMemberAdded = useCallback(
    (data) => {
      if (data.channel_id === channelId && onMembersUpdated) {
        onMembersUpdated("member_added", data.member);
      }
    },
    [channelId, onMembersUpdated],
  );

  const handleMemberRemoved = useCallback(
    (data) => {
      if (data.channel_id === channelId && onMembersUpdated) {
        onMembersUpdated("member_removed", data.removed_user_id);
      }
    },
    [channelId, onMembersUpdated],
  );

  const handleMemberListUpdate = useCallback(
    (data) => {
      if (data.channel_id === channelId && onMembersUpdated) {
        onMembersUpdated("list_updated", data.members);
      }
    },
    [channelId, onMembersUpdated],
  );

  useEffect(() => {
    if (!channelId) return;

    const eventHandler = (data) => {
      const command = data?.command || data?.type;

      switch (command) {
        case "group_member_added":
          handleMemberAdded(data);
          break;
        case "group_member_removed":
          handleMemberRemoved(data);
          break;
        case "group_members_list":
          handleMemberListUpdate(data);
          break;
        default:
          break;
      }
    };

    subscriptionHandlerRef.current = subscribeToSocketMessages(eventHandler);

    return () => {
      if (subscriptionHandlerRef.current) {
        subscriptionHandlerRef.current();
      }
      subscriptionHandlerRef.current = null;
    };
  }, [
    channelId,
    handleMemberAdded,
    handleMemberRemoved,
    handleMemberListUpdate,
    subscribeToSocketMessages,
  ]);

  return { sendCommand };
};
